//
//
//
//
//
//
//
//
//
//
//
//
//
//

var map
export default {
	data(){
		return{
			info:'',
			list: [{
			  img: require('@/static/service/scenicSpot.png'),
			  imgActive: require('@/static/service/scenicSpot_active.png'),
			  name: '风景'
			},
			{
			  img: require('@/static/service/hotel.png'),
			  imgActive: require('@/static/service/hotel_active.png'),
			  name: '住宿'
			},
			{
			  img: require('@/static/service/cate.png'),
			  imgActive: require('@/static/service/cate_active.png'),
			  name: '餐饮'
			},
			{
			  img: require('@/static/service/p.png'),
			  imgActive: require('@/static/service/p_active.png'),
			  name: '停车'
			},
			{
			  img: require('@/static/service/wc.png'),
			  imgActive: require('@/static/service/wc_active.png'),
			  name: '厕所'
			}
			],
			pois:[
						{
							"parent":[],
							"address":"同光路与同志街交叉口西50米",
							"distance":[],
							"biz_ext":{
								"cost":[],
								"rating":"2.5"
							},
							"pname":"吉林省",
							"importance":[],
							"biz_type":[],
							"cityname":"长春市",
							"type":"公共设施;公共厕所;公共厕所",
							"photos":[
								{
									"provider":[],
									"title":[],
									"url":"http://store.is.autonavi.com/showpic/547504af8b3ce1bbea635e6d8e26c0fc"
								},
								{
									"provider":[],
									"title":[],
									"url":"http://store.is.autonavi.com/showpic/556ffa83a310390a88c214fd"
								}
							],
							"typecode":"200300",
							"shopinfo":"2",
							"poiweight":[],
							"childtype":[],
							"adname":"朝阳区",
							"name":"公共厕所",
							"location":"125.317626,43.869637",
							"tel":[],
							"shopid":[],
							"id":"B0FFH5HWPZ"
						},
						{
							"parent":[],
							"address":"佳园路附近",
							"distance":[],
							"biz_ext":{
								"cost":[],
								"rating":"3.5"
							},
							"pname":"吉林省",
							"importance":[],
							"biz_type":[],
							"cityname":"长春市",
							"type":"公共设施;公共厕所;公共厕所",
							"photos":[
								{
									"provider":[],
									"title":[],
									"url":"http://store.is.autonavi.com/showpic/55784ac0a3109f1e8a160b0d"
								},
								{
									"provider":[],
									"title":[],
									"url":"http://store.is.autonavi.com/showpic/d255f1a42e887a8d0fe6985a1b863bb9"
								}
							],
							"typecode":"200300",
							"shopinfo":"2",
							"poiweight":[],
							"childtype":[],
							"adname":"朝阳区",
							"name":"公共厕所",
							"location":"125.247924,43.820753",
							"tel":[],
							"shopid":[],
							"id":"B01AF0CFF8"
						}],
						mapCenter:[125.247924,43.820753],
						m:[]
		}
	},
	onReady() {
		this.init()
	},
	methods:{
		gg(){
			console.log(11)
		},
		init(){
			map = new AMap.Map(('container'),{
				zoom: 11
			});
			var _this=this
			map.setCenter(this.mapCenter)				
			AMapUI.loadUI(['overlay/SimpleInfoWindow'], function(SimpleInfoWindow) {
					_this.pois.forEach(t=>{
						let loc=t.location.split(',')
						let g={
							lat:loc[1],
							lng:loc[0],
							P:loc[1],
							Q:loc[0]
						}
						var marker = new AMap.Marker({
						    map: map,
						    zIndex: 9999999,
						    position: g
						});
						_this.m.push(marker)
						var infoWindow = new SimpleInfoWindow({
						    //模板, underscore
						    infoTitle: '',
						    infoBody: '<div class="contain">' +
						        //<%= 原值插入 ..
								'<div class="left"><p class="title"><%- title %></p>'+
						        //<%- html编码后插入
						        '<%- body %></div><div class="right"><div class="text">查看路线</div></div>' +
						        '</div>',
						    //模板数据
						    infoTplData: {
						        title: t.name,
						        body: `${t.address}`
						    },
										
						    //基点指向marker的头部位置
						    offset: new AMap.Pixel(0, -31)
						});
						function openInfoWin() {								
						    infoWindow.open(map, marker.getPosition());
						}
						infoWindow.get$InfoBody().on('click', '.right', function(event) {
							//阻止冒泡
							event.stopPropagation();
							console.log(marker.getPosition())
							_this.gg()
							infoWindow.close(map, marker.getPosition())
							map.remove(_this.m)
						});			
						//marker 点击时打开
						AMap.event.addListener(marker, 'click', function() {
						    openInfoWin();
						});
					})
			    });
		}
	}
}
